import AppError from 'errors/app-error'

export default class UnauthorizedError extends AppError {
  constructor() {
    super()
    this.statusCode = 403
    this.message = 'Unauthorized'
  }
}
